import {Pessoas} from '../Modelos/Pessoas';
import { Tabelas_Dados_Adicionais } from './Tabelas_Dados_Adicionais';

export class Fornecedores
{
    public id_forn: number = 0;
    public pessoa: Pessoas = new Pessoas();
    public inativo_forn: string = '';
    public dados_adicionais: Tabelas_Dados_Adicionais[] = [];    
}